export const Config = {
    backendUrl: process.env.REACT_APP_BACKEND_URL,
    enableCustomerApi: process.env.REACT_APP_ENABLE_CUSTOMER_TOKENS === '1',
}
